import { CanMatchFn } from '@angular/router';

/** Mantido em sincronia com `availableLangs` em transloco.module.ts. */
const SUPPORTED_LANGS = ['pt', 'en'];

/**
 * `:lang` aceita qualquer segmento — paths como /assets, /assets.json (bots,
 * scanners) eram tratados como idioma válido e disparavam o bootstrap completo
 * (locales+settings+tenant+menus) a cada pedido. Só deixa passar idiomas reais;
 * o resto cai no wildcard `**` sem tocar no backend.
 */
export const validLangGuard: CanMatchFn = (_route, segments) =>
  SUPPORTED_LANGS.includes(segments[0]?.path);
